module.exports = __webpack_public_path__ + "img/photoshop.026403ae.png";